var _circle, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStuckDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "people - discord"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 70",
    cx: 23.9993,
    cy: 24.5994,
    r: 23.9993,
    fill: "#D6BCFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3496 10.95H31.6496C34.9633 10.95 37.6496 13.6362 37.6496 16.95V32.25C37.6496 35.5637 34.9633 38.25 31.6496 38.25H16.3496C13.0359 38.25 10.3496 35.5637 10.3496 32.25V16.95C10.3496 13.6362 13.0359 10.95 16.3496 10.95Z",
    fill: "#6941C5",
    stroke: "#171923",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3563_4827",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 15,
    width: 24,
    height: 19
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skillIconsDiscord0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.75 15.9375H35.25V33.3671H12.75V15.9375Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3563_4827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.7971 17.4901C30.3384 16.8204 28.7989 16.3429 27.2173 16.0695C27.2029 16.0669 27.1881 16.0688 27.1749 16.0751C27.1617 16.0813 27.1508 16.0916 27.1437 16.1044C26.946 16.4561 26.7268 16.9151 26.5735 17.2757C24.844 17.0168 23.1236 17.0168 21.4296 17.2757C21.2762 16.907 21.0492 16.4561 20.8505 16.1044C20.8431 16.0918 20.8322 16.0818 20.819 16.0756C20.8059 16.0694 20.7912 16.0673 20.7768 16.0695C19.1951 16.3424 17.6556 16.8199 16.197 17.4901C16.1846 17.4954 16.174 17.5044 16.1669 17.5159C13.25 21.8737 12.451 26.1244 12.843 30.3225C12.8441 30.3328 12.8472 30.3427 12.8522 30.3518C12.8573 30.3608 12.8641 30.3688 12.8722 30.3751C14.7966 31.7885 16.6609 32.6465 18.4905 33.2152C18.5047 33.2194 18.5199 33.2192 18.534 33.2146C18.5481 33.21 18.5605 33.2012 18.5694 33.1893C19.0022 32.5982 19.388 31.9751 19.7189 31.3198C19.7234 31.3108 19.726 31.301 19.7265 31.2909C19.727 31.2809 19.7253 31.2708 19.7216 31.2615C19.7179 31.2521 19.7123 31.2436 19.7051 31.2366C19.6979 31.2296 19.6893 31.2241 19.6798 31.2207C19.0678 30.9885 18.4852 30.7055 17.9247 30.3841C17.9145 30.3781 17.9059 30.3697 17.8997 30.3596C17.8936 30.3495 17.89 30.338 17.8893 30.3262C17.8886 30.3143 17.8908 30.3025 17.8957 30.2918C17.9007 30.281 17.9082 30.2716 17.9176 30.2644C18.0359 30.176 18.1521 30.085 18.2661 29.9913C18.2761 29.983 18.2882 29.9777 18.3011 29.976C18.3139 29.9742 18.327 29.9761 18.3388 29.9814C22.0212 31.6626 26.0076 31.6626 29.6464 29.9814C29.6583 29.9758 29.6715 29.9736 29.6846 29.9752C29.6976 29.9768 29.7099 29.9821 29.7201 29.9904C29.8343 30.0846 29.9508 30.176 30.0695 30.2644C30.079 30.2715 30.0866 30.2809 30.0916 30.2916C30.0966 30.3023 30.0989 30.3141 30.0983 30.3259C30.0977 30.3378 30.0942 30.3492 30.0881 30.3594C30.082 30.3695 30.0735 30.378 30.0633 30.3841C29.5026 30.7116 28.9151 30.9911 28.3073 31.2198C28.2979 31.2234 28.2893 31.2289 28.2822 31.2361C28.275 31.2432 28.2695 31.2518 28.2659 31.2613C28.2623 31.2707 28.2607 31.2808 28.2613 31.2909C28.2619 31.301 28.2646 31.3108 28.2692 31.3198C28.6058 31.9699 28.9896 32.5945 29.4176 33.1884C29.4263 33.2006 29.4386 33.2097 29.4528 33.2145C29.4669 33.2193 29.4823 33.2195 29.4966 33.2152C31.335 32.6465 33.1993 31.7885 35.1238 30.3751C35.1321 30.3691 35.1389 30.3613 35.144 30.3524C35.149 30.3435 35.1521 30.3336 35.1531 30.3234C35.6222 25.47 34.3673 21.2541 31.8263 17.5168C31.8201 17.5047 31.8097 17.4952 31.7971 17.4901ZM20.2688 27.7664C19.1601 27.7664 18.2466 26.7486 18.2466 25.4986C18.2466 24.2486 19.1424 23.2308 20.2688 23.2308C21.4039 23.2308 22.3085 24.2576 22.2907 25.4986C22.2907 26.7486 21.3951 27.7664 20.2688 27.7664ZM27.7451 27.7664C26.6364 27.7664 25.723 26.7486 25.723 25.4986C25.723 24.2486 26.6187 23.2308 27.7451 23.2308C28.8802 23.2308 29.7848 24.2576 29.7671 25.4986C29.7671 26.7486 28.8802 27.7664 27.7451 27.7664Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuckDiscord);
export default __webpack_public_path__ + "static/media/StuckDiscord.2aef1aead60bcdb4336116a45b4ac631.svg";
export { ForwardRef as ReactComponent };